/**
 * :: USAGE ::
 *
 * "subPath" is NOT expected to use on component level since it is not a full path
 * "path" is expected to use for page navigation on component level if there is no additional param to resolve
 * "pathResolver" is expected to use when the url needs to combine with some additional params
 * "canonicalPathResolver" is expected for SEO indexed page only
 * "alternatePaths" is expected to use as possible alternate path options for the page
 *
 */

export const baseUrl = {
  providerReview: '/HOTEL',
  providerReviewVoice: '/hotel/voice',
  myReview: '/reviewer/main',
  otherUserReview: '/reviewer',
  myReviewEdit: '/reviewer/edit',
  postReview: '/entry/post',
  editReview: '/entry/edit',
} as const;

const paths = {
  top: {
    path: '/',
    pathResolver: () => `/`,
    canonicalPathResolver: () => `/`,
  },

  providerReview: {
    path: `${baseUrl.providerReview}/:providerId/review.html`,
    dynamicPath: `${baseUrl.providerReviewVoice}/:providerId/:reviewId?`,
    pathResolver: (pathId: string) => `${baseUrl.providerReviewVoice}/${pathId}`,
    canonicalPathResolver: (pathId: string) => `${baseUrl.providerReview}/${pathId}/review.html`,
  },

  myReviewPage: {
    path: `${baseUrl.myReview}`,
    pathResolver: `${baseUrl.myReview}`,
  },
  otherUserReviewPage: {
    path: `${baseUrl.otherUserReview}/:userId`,
    pathResolver: (userId: string) => `${baseUrl.otherUserReview}/${userId}`,
  },

  editReviewPage: {
    path: baseUrl.myReviewEdit,
  },
  reviewPostPage: {
    path: baseUrl.postReview,
  },
  reviewEditPage: {
    path: baseUrl.editReview,
  },
} as const;

export default paths;
